/**
 * Coerce an unknown value (typically a `catch` block parameter) into a real
 * `Error` so it's safe to pass to `Bugsnag.notify` and other consumers that
 * require a proper `Error` instance.
 *
 * Caught values can be anything in JS — a string, a plain object, even
 * `undefined` from `throw undefined`. Bugsnag's `notify` accepts non-Error
 * input but loses the stack and class metadata. Wrap once at the boundary
 * so call sites stay terse.
 */
export function toError(e: unknown): Error {
  if (e instanceof Error) return e;
  if (typeof e === "string") return new Error(e);

  try {
    const serialized = JSON.stringify(e);
    if (serialized !== undefined) return new Error(serialized);
  } catch {
    // Circular references and values such as BigInt cannot be JSON serialized.
  }

  try {
    return new Error(String(e));
  } catch {
    return new Error("Unknown error");
  }
}
